

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#FFBE18E5" type = "square-jelly-box" [fullScreen] = "true">
  <p style="color: white" > جارٍ التحميل... </p>
</ngx-spinner>
<router-outlet></router-outlet>
